import { useCallback, useEffect, useRef, useState } from "react";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const useCatalogOperations = (clientId, sourceId, getAuthHeaders) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const reload = useRef(null);
  const auth = useRef(getAuthHeaders);
  auth.current = getAuthHeaders;

  useEffect(() => {
    let disposed = false, timer, controller, sequence = 0;
    setData(null); setError(null); setLoading(Boolean(sourceId));
    if (!clientId || !sourceId) return undefined;
    const load = async () => {
      const ticket = ++sequence;
      clearTimeout(timer);
      controller?.abort();
      controller = new AbortController();
      let active = false;
      try {
        const res = await fetch(`${API_URL}/api/admin/catalog/${encodeURIComponent(clientId)}/sources/${encodeURIComponent(sourceId)}/operations`, {
          headers: auth.current(), signal: controller.signal, cache: "no-store",
        });
        if (!res.ok) throw new Error(`Kunde inte läsa driftstatus (HTTP ${res.status}).`);
        const next = await res.json();
        if (disposed || ticket !== sequence) return;
        active = Boolean(next.import_in_progress);
        setData(next); setError(null);
      } catch (e) {
        if (!disposed && ticket === sequence && e.name !== "AbortError") setError(e.message);
      } finally {
        if (!disposed && ticket === sequence) {
          setLoading(false);
          timer = setTimeout(load, active ? 3000 : 15000);
        }
      }
    };
    reload.current = load;
    load();
    return () => { disposed = true; sequence += 1; clearTimeout(timer); controller?.abort(); reload.current = null; };
  }, [clientId, sourceId]);

  const refresh = useCallback(() => reload.current?.(), []);
  return { data, error, loading, refresh };
};